import singlePromotionHeader from "@areas/Brand/Views/Shared/Partials/js/xyl.views.singlePromotionHeader";
import countrySelector from "@areas/Core/Views/Shared/Partials/js/xyl.views.countryselector.js";
import campaignNavigation from "@areas/Core/Views/Shared/Partials/js/xyl.views.scrollingCampaignNavigation";
import type { XylView } from "../../helpers/xyl-view-helpers";

export const partials: XylView[] = [singlePromotionHeader, campaignNavigation, countrySelector];
